document.addEventListener("DOMContentLoaded", function() {
  const formContainer = document.querySelector('.sk-form');
    formContainer.addEventListener('input', function(event) {
      const input = event.target.closest('.js-input');
      if (!input) return;
      const parent = input.closest('.sk-form__field');
      if (input.value.trim() !== '') {
        parent.classList.add('has-content');
      } else {
        parent.classList.remove('has-content');
      }
    });
});
